import {
  SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_BEGIN,
  SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_SUCCESS,
  SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_FAILURE,
  SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getAllSystemConfig(tag) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
        request({
          method:'get',
          url:'/v2/admin/system/config/list',
          data:{typeTag:tag},
        }).then( data => {
            console.log(data);
            dispatch({
                type: SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_SUCCESS,
                data: {tag,data},
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
    
    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetAllSystemConfigError() {
  return {
    type: SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getAllSystemConfigPending: true,
        getAllSystemConfigError: null,
      };

    case SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_SUCCESS:
      // The request is success
        const byId = {};
        const items = [];
        console.log(action)
        action.data.data.list.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
        let systemConfigList = {}
        systemConfigList[action.data.tag] = items;
    
      return {
        ...state,
        tagSystemConfigById:byId,
        tagSystemConfigList:systemConfigList,
        getAllSystemConfigPending: false,
        getAllSystemConfigError: null,
      };

    case SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_FAILURE:
      // The request is failed
      return {
        ...state,
        getAllSystemConfigPending: false,
        getAllSystemConfigError: action.data.error,
      };

    case SYSTEMCONFIG_GET_ALL_SYSTEM_CONFIG_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getAllSystemConfigError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/getAllSystemConfig.js